<template>
    <app-layout title="Edit Profile">
        <form @submit.prevent="handleSubmit">
            <page-header>
                <template #title>Edit Profile</template>

                <template #actions>
                    <jet-button v-show="form.isDirty" type="submit" class="leading-none" :disabled="form.processing" >
                        Save
                    </jet-button>

                    <jet-tertiary-button
                        :disabled="form.processing"
                        :href="backUrl"
                        class="leading-none"
                    >
                        Close
                    </jet-tertiary-button>
                </template>
            </page-header>

            <div class="px-2 md:px-4 lg:px-8">
                <div class="\flex flex-wrap box justify-between gap-y-2 gap-x-8 xl:gap-x-12">
                    <div class="w-1/2">
                        <div class="flex mb-2">
                            <jet-label for="note" value="Order Notes / Shipping Instructions" class="w-32 align-top leading-7" />
                            <div class="flex flex-1 flex-col">
                                <textarea v-model="form.order_notes" class="mt-2 block rounded w-full h-42" maxlength="1000" rows="10" placeholder="Enter a message"></textarea>
                                <jet-input-error :message="$page.props.errors.order_notes" class="mt-1" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </app-layout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import JetButton from '@/Jetstream/Button';
import JetLabel from '@/Jetstream/Label';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';

export default {
    setup(props) {
        const form = useForm({
            order_notes: props.customer.order_notes,
        })

        return { form }
    },

    components: {
        AppLayout,
        PageHeader,
        JetButton,
        JetLabel,
        JetTertiaryButton,
        JetConfirmationModal,
    },

    props: ['customer'],

    data() {
        return {
            formRoute: this.route('activecustomer.profile.update'),
        }
    },

    methods: {
        handleSubmit () {
            if(!this.form.processing) {
                const returnUrl = route().params.return;

                this.form
                    .transform((data) => ({
                        ...data,
                    }))
                    .submit('put', route('activecustomer.profile.update', {
                        return: returnUrl,
                    }));
            }
        },
    },

    computed: {
        backUrl () {
            return route('activecustomer.profile');
        },
    },
}
</script>

<style>
.multi-custom {
    min-height: 1.5rem;
}
</style>
